export function convertToEmbedUrl(url: string): string {
  if (!url || !url.trim()) return url;

  const trimmedUrl = url.trim();

  // If it's already an embed URL, return as is
  if (
    trimmedUrl.includes("/embed/") ||
    trimmedUrl.includes("player.vimeo.com")
  ) {
    return trimmedUrl;
  }

  // YouTube URL patterns to handle
  const youtubePatterns = [
    // Standard YouTube URLs
    /(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?v=([a-zA-Z0-9_-]+)/,
    // YouTube short URLs
    /(?:https?:\/\/)?youtu\.be\/([a-zA-Z0-9_-]+)/,
    // YouTube URLs with additional parameters
    /(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?.*[&?]v=([a-zA-Z0-9_-]+)/,
  ];

  for (const pattern of youtubePatterns) {
    const match = trimmedUrl.match(pattern);
    if (match && match[1]) {
      return `https://www.youtube.com/embed/${match[1]}`;
    }
  }

  // Vimeo URL patterns
  const vimeoPatterns = [
    // Standard Vimeo URLs
    /(?:https?:\/\/)?(?:www\.)?vimeo\.com\/(\d+)/,
    // Vimeo URLs with additional parameters
    /(?:https?:\/\/)?(?:www\.)?vimeo\.com\/(\d+)(?:\?.*)?/,
  ];

  for (const pattern of vimeoPatterns) {
    const match = trimmedUrl.match(pattern);
    if (match && match[1]) {
      return `https://player.vimeo.com/video/${match[1]}`;
    }
  }

  // If no patterns match, return the original URL
  return trimmedUrl;
}

export function isValidVideoUrl(url: string): boolean {
  if (!url || !url.trim()) return false;

  const trimmedUrl = url.trim();

  // Check if it's already a valid embed URL
  if (
    trimmedUrl.includes("/embed/") ||
    trimmedUrl.includes("player.vimeo.com")
  ) {
    return true;
  }

  // Check if it's a convertible YouTube or Vimeo URL
  const youtubePattern =
    /(?:https?:\/\/)?(?:(?:www\.)?youtube\.com\/watch\?.*[&?]v=|(?:www\.)?youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]+)/;
  const vimeoPattern = /(?:https?:\/\/)?(?:www\.)?vimeo\.com\/(\d+)/;

  return youtubePattern.test(trimmedUrl) || vimeoPattern.test(trimmedUrl);
}
